import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 80px);
  padding: 24px;

  @media (max-width: 900px) {
    padding: 0;
    min-height: calc(100vh - 45px);
  }
`;

export const Panel = styled.div`
  display: flex;
  width: 100%;
  max-width: 960px;
  min-height: 560px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 24px 60px -16px rgba(20, 10, 0, 0.25);
  animation: panel-in 0.45s ease-out;

  @keyframes panel-in {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 900px) {
    flex-direction: column;
    border-radius: 0;
    box-shadow: none;
    min-height: 100%;
  }
`;

export const BrandSide = styled.div`
  position: relative;
  flex: 1;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 12px;
  padding: 48px 40px;
  color: #fff;
  /* mesma cor padrao do Layout.Sider/Layout.Header (antd) usada no resto do app */
  background: #001529;

  svg {
    opacity: 0.85;
    margin-bottom: 8px;
  }

  @media (max-width: 900px) {
    min-width: 100%;
    padding: 40px 24px;
    min-height: 200px;
  }
`;

export const BrandKicker = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.85;
`;

export const BrandTitle = styled.h1`
  font-size: 1.85rem;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
`;

export const BrandSubtitle = styled.p`
  font-size: 0.95rem;
  line-height: 1.5;
  max-width: 320px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
`;

export const FormSide = styled.div`
  flex: 1;
  min-width: 340px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #fff;
  padding: 56px 48px;

  @media (max-width: 900px) {
    min-width: 100%;
    padding: 40px 24px;
  }
`;

export const ContainerForm = styled.div`
  width: 100%;
`;
